// extracted by mini-css-extract-plugin
export default {"container":"ConfigurationTime_container__LmW5R"};